<template>
  <div class="reassessment-card border rounded p-2 mb-2">
    <div class="d-flex justify-content-between align-items-baseline mb-1">
      <b class="small-text">ประเมินก่อนกลับ (Reassessment)</b>
      <span
        class="description font-weight-bold"
        :class="missing.length ? 'text-danger' : 'text-success'"
      >
        {{ missing.length ? `ยังไม่ได้ตอบ ${missingCount} ข้อ` : "ครบแล้ว" }}
      </span>
    </div>

    <div v-for="q in questions" :key="q.key" class="ra-row">
      <div class="d-flex justify-content-between align-items-center">
        <span class="small-text">{{ q.label }}</span>
        <b-button-group size="sm">
          <b-button
            v-for="o in q.options"
            :key="String(o.value)"
            :variant="buttonVariant(q.key, o)"
            @click="set(q.key, o.value)"
            >{{ o.label }}</b-button
          >
        </b-button-group>
      </div>
      <b-form-input
        v-if="needsDetail(q)"
        :id="`${idPrefix}-${q.detail}`"
        :value="value[q.detail]"
        size="sm"
        class="mt-1"
        :class="{ 'is-invalid': missing.includes(q.detail) }"
        placeholder="ระบุรายละเอียด (บังคับ)"
        @input="set(q.detail, $event)"
      />
    </div>

    <div class="ra-row">
      <span class="small-text">Pain score (0–10)</span>
      <b-button-group size="sm" class="d-flex mt-1">
        <b-button
          v-for="n in 11"
          :key="n - 1"
          class="px-0"
          :variant="value.painScore === n - 1 ? 'primary' : 'outline-primary'"
          @click="set('painScore', n - 1)"
          >{{ n - 1 }}</b-button
        >
      </b-button-group>
    </div>

    <div class="ra-row d-flex justify-content-between align-items-center">
      <span class="small-text">Post-op instruction</span>
      <div>
        <b-button
          size="sm"
          class="mr-1"
          :variant="value.instructionVerbal ? 'primary' : 'outline-primary'"
          @click="set('instructionVerbal', !value.instructionVerbal)"
          >Verbal</b-button
        >
        <b-button
          size="sm"
          :variant="value.instructionWritten ? 'primary' : 'outline-primary'"
          @click="set('instructionWritten', !value.instructionWritten)"
          >Written</b-button
        >
      </div>
    </div>
    <div class="description text-muted">
      Discharge time บันทึกอัตโนมัติเมื่อกดบันทึก/ส่งชำระเงิน
    </div>
  </div>
</template>

<script>
import { missingReassessmentFields } from "@/utils/reassessment";

const YES_NO = [
  { label: "No", value: false, abnormal: false },
  { label: "Yes", value: true, abnormal: true },
];

export default {
  name: "ReassessmentCard",
  props: {
    value: { type: Object, required: true },
    idPrefix: { type: String, default: "ra" },
  },
  data() {
    return {
      questions: [
        { key: "bleeding", detail: "bleedingDetail", label: "Bleeding", options: YES_NO },
        { key: "swelling", detail: "swellingDetail", label: "Swelling", options: YES_NO },
        {
          key: "generalCondition",
          detail: "generalDetail",
          label: "General condition",
          options: [
            { label: "Stable", value: "STABLE", abnormal: false },
            { label: "Dizziness / Syncope", value: "DIZZINESS_SYNCOPE", abnormal: true },
          ],
        },
        {
          key: "allergicReaction",
          detail: "allergicDetail",
          label: "Allergic / adverse reaction",
          options: YES_NO,
        },
      ],
    };
  },
  computed: {
    missing() {
      return missingReassessmentFields(this.value);
    },
    missingCount() {
      return this.missing.length;
    },
  },
  methods: {
    set(key, v) {
      this.$emit("input", { ...this.value, [key]: v });
    },
    needsDetail(q) {
      const opt = q.options.find(o => o.value === this.value[q.key]);
      return !!(opt && opt.abnormal);
    },
    buttonVariant(key, option) {
      if (this.value[key] !== option.value) return "outline-primary";
      return option.abnormal ? "danger" : "primary";
    },
  },
};
</script>

<style scoped>
.ra-row {
  padding: 0.2rem 0;
  border-bottom: 1px solid #f1f3f5;
}
</style>
